import styled from "styled-components/macro";
const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";

export const ServicesContainer = styled.div`
  /* height: 800px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  margin: auto;
  max-width: 1300px;
  z-index: 1;
  /* background: aqua; */

  @media screen and (max-width: 1370px) {
    padding: 0 0.5rem;
  }

  /* @media screen and (max-width: 480px) {
    height: 1300px;
  } */
`;
export const ServicesWrapper = styled.div`
  /* max-width: 1260px;  */
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 50px;
  padding: 0 50px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 786px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;
export const ServicesCard = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;
export const ServicesIcon = styled.img`
  height: 160px;
  width: 160px;
  margin-bottom: 10px;
`;
export const ServicesH1 = styled.h1`
  font-size: 2.5rem;
  /* color: #fff; */
  margin-bottom: 64px;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;
export const ServicesH2 = styled.h2`
  font-size: 1rem;
  margin-bottom: 10px;
`;

export const ServicesP = styled.p`
  font-size: 1rem;
  text-align: center;
`;

// Property Search Box

export const PropertySearchBox = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 16px 20px #0000000f;
  border: 1px solid #dadada;
  border-radius: 16px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-top: -4rem;
  width: 80%;

  @media screen and (max-width: 1440px) {
    width: 80%;
  }

  @media screen and (max-width: 480px) {
    width: 90%;
  }
`;

export const PropertyText = styled.div`
  color: #606060;
  padding: 1rem 0rem;
  margin-left: 1.2rem;
  cursor: pointer;

  &:first-child {
    margin-left: ${defaultLanguage === "ar" ? "1.2rem" : 0};
  }

  @media screen and (max-width: 480px) {
    padding: 0.8rem 0rem;
  }
`;

export const PropertyTypes = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  overflow-x: scroll;
  padding: 0rem 1rem;
  direction: ${defaultLanguage === "ar" ? "rtl" : "ltr"};

`;

export const PropertyDividerLine = styled.div`
  border: 1px solid #ececec;
`;

export const PropertySearch = styled.div`
  display: flex;
  width: 100%;
  align-items: center;

  @media screen and (max-width: 768px) {
    font-size: 2rem;
  }
  @media screen and (max-width: 480px) {
    flex-direction: column;
  }


`;

export const PropertySearchIcon = styled.div`
  margin-left: 1rem;
  width: 3%;
  font-size: 1.2rem;
  @media screen and (max-width: 480px) {
    margin-left: 0.4rem;
  }
`;

export const PropertySearchInputFeild = styled.input`
  height: auto;
  border: none;
  outline: none;
  width: 100%;
  text-align: left;
  font-weight: 300;
  font-size: 0.9rem;
  font-family: Montserrat !important;
  letter-spacing: 0px;
  opacity: 0.8;
  padding: 0px 9px;
  color: rgb(49, 53, 59);
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 480px) {
    font-size: 0.8rem;
    padding: 0px 16px;
  }
`;

export const PropertySaleButton = styled.div`
  /* box-shadow: rgb(0 0 0 / 19%) 0px 0px 10px; */
  border-radius: 0px 0px 0px 16px;
  opacity: 1;
  /* margin: 0.1em; */
  white-space: nowrap;
  /* padding: 1.2em 2.5em; */
  /* border: 1px solid #dadada; */
  background: #ebf0f8 0% 0% no-repeat padding-box;
  color: #15396d;
  outline: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out 0s;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  font-family: Montserrat;
  letter-spacing: 0px;

  @media screen and (max-width: 480px) {
    width: 100%;
    display: unset;
  }
`;

export const PropertySearchButton = styled.div`
  /* box-shadow: rgb(0 0 0 / 19%) 0px 0px 10px; */
  border-radius: 4px;
  opacity: 1;
  /* margin: 0.1em; */
  white-space: nowrap;
  padding: 0.8em 1.8em;
  border: 1px solid #dadada;
  background: #ed7d2b 0% 0% no-repeat padding-box;
  color: #ffffff;
  outline: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out 0s;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  font-family: Montserrat;
  letter-spacing: 0px;
  margin-right: 0.5rem;

  @media screen and (max-width: 768px) {
    display: none;
  }

`;

export const PropertyLocation = styled.img`
  margin-right: 0.7rem;
  @media screen and (max-width: 480px) {
    width: 10%;
  }
`;

export const PropertyDropdown = styled.span`
  margin-right: 0.7rem;
`;

export const InputFeild = styled.input`
  height: auto;
  border: none;
  outline: none;
  width: 100%;
  text-align: left;
  font-weight: 500;
  font-size: 0.9rem;
  font-family: Montserrat;
  letter-spacing: 0px;
  opacity: 1;
  padding: 0 9px;
  color: #31353b;
  text-align: ${defaultLanguage === "ar" ? "right" : "left"};
  @media screen and (max-width: 480px) {
    font-size: 0.8rem;
    padding: 0 16px;
  }
`;


export const TypeText = styled.span`
font-size: 0.78rem;
font-weight: 500;
white-space: nowrap;

@media screen and (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

export const PrSearchBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    direction: ${defaultLanguage === "ar" ? "rtl" : "ltr"};
    padding: ${defaultLanguage === "ar" ? "0 1rem" : "0"};
@media screen and (max-width: 480px) {
    padding: 0.6rem 0.5rem;

  }
`;


